module.exports = __webpack_public_path__ + "static/media/income-total.1375b472.svg";